<h2 mat-dialog-title mat-dialog-draggable-title>
  Loại hợp đồng/ văn bản
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>

<mat-divider></mat-divider>
<form
  name="form"
  action="#"
  #f="ngForm"
  (ngSubmit)="f.form.valid && submit()"
  appFocusFirstElement
>
  <mat-dialog-content>
    <div class="row mt-3" id="myDiv">
      <div class="col-12" style="padding: 0px 12px !important;">
        <mat-form-field style="overflow: hidden">
          <mat-label>Loại hợp đồng/ văn bản</mat-label>
          <mat-select #contractTypeSelect (focusout)="(checkFocus = true)"
                      (focus)="commonService.openComboBox(checkFocus, contractTypeSelect);" id="focusSelect" name="type" #focusSelect
                      (selectionChange)="checkFocus = false" (click)="changeData()"
                      [(ngModel)]="selectedOption" #type="ngModel"
                      [ngClass]="{ 'is-invalid': f.submitted || type.invalid }" required>
            <mat-option>
              <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate" (input)="FilterData($event)" (click)="changeData()"
                                     [placeholderLabel]="'search_form.search' | translate" [formControl]="searchCtrl">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let option of dataSelect" [value]="option.key"
                        (click)="this.commonService.closeDropdownList(this.contractTypeSelect); checkDrop = false"
                        title="{{option.title}}">
              <i class="anticon mb-1 ant-tree-switcher-line-icon anticon-file">
                <svg viewBox="64 64 896 896" fill="currentColor" width="1em" height="1em"><path d="M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"></path></svg>
              </i>
              <span class="ml-2 fix-width-input">{{option.title}}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="mt-2">
    <button
      mat-stroked-button
      color="warn"
      class="mr-3 btn-cancel"
      type="button"
      (click)="cancel()"
    >
      <mat-icon class="mr-0">cancel</mat-icon> Huỷ bỏ
    </button>
    <button
      mat-raised-button
      color="warn"
      class="btn-confirm"
      type="submit"
      [disabled]="!selectedOption"
    >
      <span><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.5 7.27783L12 12.0001M12 12.0001L3.49997 7.27783M12 12.0001L12 21.5001M21 12.0001V7.94153C21 7.59889 21 7.42757 20.9495 7.27477C20.9049 7.13959 20.8318 7.01551 20.7354 6.91082C20.6263 6.79248 20.4766 6.70928 20.177 6.54288L12.777 2.43177C12.4934 2.27421 12.3516 2.19543 12.2015 2.16454C12.0685 2.13721 11.9315 2.13721 11.7986 2.16454C11.6484 2.19543 11.5066 2.27421 11.223 2.43177L3.82297 6.54288C3.52345 6.70928 3.37368 6.79248 3.26463 6.91082C3.16816 7.01551 3.09515 7.13959 3.05048 7.27477C3 7.42757 3 7.59889 3 7.94153V16.0586C3 16.4013 3 16.5726 3.05048 16.7254C3.09515 16.8606 3.16816 16.9847 3.26463 17.0893C3.37368 17.2077 3.52346 17.2909 3.82297 17.4573L11.223 21.5684C11.5066 21.726 11.6484 21.8047 11.7986 21.8356C11.9315 21.863 12.0685 21.863 12.2015 21.8356C12.3516 21.8047 12.4934 21.726 12.777 21.5684L13 21.4445M7.5 4.50008L16.5 9.50008M22 21.5001L21 20.5001M22 18.0001C22 19.6569 20.6569 21.0001 19 21.0001C17.3431 21.0001 16 19.6569 16 18.0001C16 16.3432 17.3431 15.0001 19 15.0001C20.6569 15.0001 22 16.3432 22 18.0001Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        </span> Chọn loại
    </button>
  </mat-dialog-actions>
</form>

